















import { LoadingService } from '@/services/loadingService';
import { Component, Vue } from 'vue-property-decorator';
import TorreControlInstance from '@/pantallas/TorreControl/comunes/Instances';

@Component({
  name: 'searchSimple',
  components: {},
})
export default class searchSimple extends Vue {
  loadingService = new LoadingService();
  $snotify: any;
  isLoading: boolean = false;
  search: string = '';

  onFilterTextBoxChanged() {
    TorreControlInstance.$emit('searchSimple', this.search);
  }
}
